import React, { useState } from "react";
import { saveAs } from "file-saver";
import { createEvent } from "ics";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { _t } from "app/i18n/i18n";
import { auditAddEventToCalendar } from "lib/analytics/auditEvents";
import { DownloadFailureToast } from "./DownloadFailureToast";

export const AddEventToCalendar = ({ eventData, slotData, buttonClassName }) => {
  const [showErrorToast, setShowErrorToast] = useState(false);
  return (
    <>
      <OverlayTrigger placement="top" overlay={<Tooltip id="event-tooltip">{_t("Add to Calendar")}</Tooltip>}>
        <Button
          id="add-to-calendar"
          className={`float-right mt-auto ml-2 mr-1 position-relative btn-dark ${buttonClassName}`}
          variant=""
          onClick={() => {
            downloadCalendarInvite(eventData, slotData, setShowErrorToast);
            auditAddEventToCalendar(eventData.eventId);
          }}
        >
          <i className="fas fa-calendar-day"></i>
        </Button>
      </OverlayTrigger>
      {showErrorToast && (
        <DownloadFailureToast
          setShowErrorToast={setShowErrorToast}
          showErrorToast={showErrorToast}
        ></DownloadFailureToast>
      )}
    </>
  );
};

export const downloadCalendarInvite = (eventData, slotData, setShowErrorToast) => {
  const circleEvent = {
    start: getStartDateArray(slotData.startDateTime),
    duration: getDuration(slotData.startDateTime, slotData.endDateTime),
    title: eventData.eventName,
    description: getBody(eventData, slotData),
    location: slotData.locationURL,
    status: "CONFIRMED",
    busyStatus: "BUSY",
  };

  createEvent(circleEvent, (error, value) => {
    if (error) {
      setShowErrorToast(true);
      return;
    }
    const icsBlob = new Blob([value], { type: "text/calendar;charset=utf-8" });
    saveAs(icsBlob, eventData.eventName + ".ics");
  });
};

const getStartDateArray = (startDateFormatted) => {
  const date = new Date(startDateFormatted);
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const hours = date.getHours();
  const minutes = date.getMinutes();
  return [year, month, day, hours, minutes];
};
const getDuration = (startDateStr, endDateStr) => {
  const startDate = new Date(startDateStr);
  const endDate = new Date(endDateStr);
  const diffInMillSec = endDate - startDate;

  const diffInMins = Math.floor(diffInMillSec / 1000 / 60);
  const hours = Math.floor(diffInMins / 60);
  const minutes = diffInMins % 60;
  return { hours, minutes };
};
const getVisibleDate = (dateStr) => {
  const date = new Date(dateStr);
  const weekdays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  const dayOfWeek = weekdays[date.getDay()];
  const month = months[date.getMonth()];
  const day = date.getDate();
  const year = date.getFullYear();
  return dayOfWeek + ", " + month + " " + day + ", " + year;
};
const getBody = (eventData, slotData) => {
  let body = "";
  body = body.concat(
    eventData.eventName +
      "\n\n" +
      "Date: " +
      getVisibleDate(slotData.startDateTime) +
      "\n\n" +
      "Time: " +
      slotData.startTimeFormatted +
      " - " +
      slotData.endTimeFormatted +
      "\n\n",
  );

  if (slotData?.locationURL) {
    body = body.concat(`Meeting Details:\n` + slotData.locationNoteInvestor + "\n\n");
  }

  if (slotData?.speakers?.length >= 1) {
    var name = "";
    slotData.speakers.forEach(function (speaker) {
      name = name + speaker.displayName + "; ";
    });
    body = body.concat("Speaker Details: \nSpeaker(s) : " + name);
  }

  return body;
};
